import { booleanAttribute, ChangeDetectionStrategy, Component, inject, input } from "@angular/core";

import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

import { CustomIconComponent } from "../custom-icon/custom-icon.component";

@Component({
  selector: "component-modal",
  templateUrl: "./modal.component.html",
  styleUrl: "./modal.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CustomIconComponent]
})
export class ModalComponent {
  readonly showClose = input(true, { transform: booleanAttribute });
  readonly showHeader = input(true, { transform: booleanAttribute });
  readonly showFooter = input(true, { transform: booleanAttribute });

  protected readonly activeModal = inject(NgbActiveModal);
}
